/// <reference path="../../types.d.ts" />

import { connect } from 'react-redux';

import { Organization } from './organization';
import { mapDispatchToProps, mapStateToProps } from './organization-utils';

export default connect(mapStateToProps, mapDispatchToProps)(Organization);
